/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={13} height={9} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.308 1L1 4.053l3.036 3.316M7 7h4.988"
      stroke="#4C9AFF"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
